import { render, staticRenderFns } from "./CustomerRequestRefundReasonStep.vue?vue&type=template&id=45bf5cb4&"
import script from "./CustomerRequestRefundReasonStep.vue?vue&type=script&lang=js&"
export * from "./CustomerRequestRefundReasonStep.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRequestRefundReasonStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports